import React from "react";

export default function Loding() {
  return <div>Loding......</div>;
}
